import React, { useState } from "react";
import { Container } from 'reactstrap';
import "../styles/FaqSection.css";

const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "How do I start playing Orion Stars slots and other games?",
            answer: "Scan the QR code shared on the homepage to download and install our app on Android or iOS devices. Follow the instructions on the homepage to download and play our games on Windows."
        },
        {
            question: "What types of games are available on Orion Stars?",
            answer: "You can play fish games, slots, adventure games, and many other games. "
        },
        {
            question: "How do I earn bonuses and rewards on Orion Stars?",
            answer: "You can claim a 200% bonus on the first deposit. As you level up, you can unlock more rewards and bonuses.  "
        },
        {
            question: "Is my personal information safe on Orion Stars?",
            answer: "Yes. Orion Stars adheres to user data protection laws and uses advanced encryption technologies to protect your personal information."
        },
        {
            question: "Can I switch devices and continue where I left off?",
            answer: "Yes. You can easily continue where you left off. Orion Stars offers a seamless gaming experience on all devices."
        },
    ];

    const toggleAnswer = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <React.Fragment>
            <div className="description-bg">
                <Container>
                    <h2 className="what-exactly-is-faq">FAQs (Frequently Asked Questions)</h2>
                        {faqs.map((faq, index) => (
                            <div className="faq-container" key={index} onClick={() => toggleAnswer(index)}>
                                <div className="question">
                                    <span>{faq.question}</span>
                                    <span className={`arrow ${activeIndex === index ? "expanded" : ""}`}>{`>`}</span>
                                </div>
                                {activeIndex === index && (
                                    <div className="answer">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}

                </Container>
            </div>
        </React.Fragment>
    );
};

export default FaqSection;
